import { render, staticRenderFns } from "./keyword-dedup-detail.component.html?vue&type=template&id=5ad7c7e0&scoped=true&external"
import script from "./keyword-dedup-detail.component.vue?vue&type=script&lang=ts"
export * from "./keyword-dedup-detail.component.vue?vue&type=script&lang=ts"
import style0 from "./keyword-dedup-detail.component.css?vue&type=style&index=0&id=5ad7c7e0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad7c7e0",
  null
  
)

export default component.exports